@if (this.view$ | async; as view) {
  <div>
    <div
      ngbDropdown
      #dropDownMenuFilters="ngbDropdown"
      class="dropdown dropdown-filter d-inline"
      autoClose="outside"
      >
      @if (activeFilters$ | async; as activeFilters) {
        <button
          type="button"
          class="btn btn-sm btn-outline-light dropdown-toggle"
          id="dropdownBasic1"
          ngbDropdownToggle
          aria-haspopup="true"
          [attr.aria-expanded]="dropDownMenuFilters.isOpen()"
          >
          <i class="mdi mdi-filter"></i>
          <span class="btn-text" translate> SEARCH_LBL_CUSTOM_FILTERS </span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          @for (propertyFilter of view.searchView.propertyFilters; track propertyFilter.name; let isFirst = $first; let
            isLast = $last) {
            @if (!propertyFilter.isReadOnly) {
              <!-- add a divider after each property-->
              @if (!isFirst) {
                <div class="dropdown-divider"></div>
              }
              <div ngbDropdown class="" [placement]="'right-top'">
                <button class="no-arrow dropdown-item dropdown-item-normal dropdown-filter" ngbDropdownToggle>
                  <span
                  [class.fw-bolder]="(activeFilters | isOneItemInPropertyActive : propertyFilter)">{{ propertyFilter.name }}</span>
                  <i class="mdi mdi-menu-right float-end"></i>
                </button>
                <div ngbDropdownMenu>
                  @for (filterItem of propertyFilter.items; track filterItem.label) {
                    <button ngbDropdownItem class="dropdown-item dropdown-item-normal dropdown-filter"
                      (click)="togglePropertyFilter(propertyFilter,filterItem ); dropDownMenuFilters.close()"
                      [class.active]="activeFilters | isPropertyActive : propertyFilter: filterItem"
                      >
                      @if (activeFilters | isPropertyActive : propertyFilter: filterItem) {
                        <span class="mdi mdi-check"></span>
                      }
                      <span [class.ms-3]="!(activeFilters | isPropertyActive : propertyFilter : filterItem)"
                        [class.fw-bolder]="(activeFilters | isPropertyActive : propertyFilter: filterItem)"
                        >
                        {{ filterItem.label }}
                      </span>
                    </button>
                  }
                </div>
              </div>
            }
          }
          @for (builtInFilterGroup of view.searchView.builtInFilterGroups; track builtInFilterGroup; let isFirst = $first; let isLast = $last) {
            <!-- add a divider if there is element before -->
            @if (isFirst && hasReadOnlyFilters(view.searchView.propertyFilters)) {
              <div class="dropdown-divider"></div>
            }
            @for (builtInFilter of builtInFilterGroup.filters; track builtInFilter.name) {
              <button
                class="dropdown-item dropdown-item-normal dropdown-filter"
            (click)="
            toggleBuiltInFilter(builtInFilter); dropDownMenuFilters.close()
          "
                [class.active]="activeFilters | isBuiltInActive : builtInFilter"
                >
                @if (activeFilters | isBuiltInActive : builtInFilter) {
                  <span
                    class="mdi mdi-check"
                  ></span>
                }
                <span
                  [class.ms-3]="!(activeFilters | isBuiltInActive : builtInFilter)"
                  [class.fw-bolder]="(activeFilters | isBuiltInActive : builtInFilter)"
                  >
                  {{ builtInFilter.text }}</span
                  >
                </button>
              }
              <!-- add a divider after each property-->
              @if (!isLast) {
                <div class="dropdown-divider"></div>
              }
            }
            @if (showCustomFilters()) {
              @let customFilters = customFilters$ | async;
              @if (!!customFilters) {
                @for (customFilter of customFilters; track customFilter; let isFirst = $first; let isLast = $last) {
                  <div>
                    <!-- add a divider if there is element before -->
                    @if (isFirst && ((view.searchView.builtInFilterGroups != null && view.searchView.builtInFilterGroups.length !== 0) ||
                      hasReadOnlyFilters(view.searchView.propertyFilters))) {
                      <div class="dropdown-divider"></div>
                    }
                    @for (domain of customFilter.domains; track domain) {
                      <button
                        class="dropdown-item dropdown"
                        type="button"
              (click)="
              changeDomainState(
                customFilters.indexOf(customFilter),
                customFilter.domains.indexOf(domain)
              )
            "
              [class.active]="
              activeFilters | isDomainActive : customFilter : domain
            "
                        >
                        <span>
                          @if (activeFilters | isDomainActive : customFilter : domain) {
                            <span
                              class="mdi mdi-check"
                            ></span>
                          }
                          @switch (domain.operator.numberOfValues) {
                            @case (1) {
                              <span
                                [class.ms-3]="!(activeFilters | isDomainActive : customFilter : domain)"
                                [class.fw-bolder]="(activeFilters | isDomainActive : customFilter : domain)"
                                >
                                {{ domain.fieldLabel }}
                                {{ domain.operator.label }}
                                @if (isValidDate(domain.text)) {
                                  {{ domain.text | date : "dd-MM-yyyy" }}
                                }
                                @else {
                                {{ domain.text }}
                              }
                            </span>
                          }
                          @case (2) {
                            <span
                              [class.ms-3]="!(activeFilters | isDomainActive : customFilter : domain)"
                              [class.fw-bolder]="(activeFilters | isDomainActive : customFilter : domain)"
                              >
                              {{ domain.fieldLabel }}
                              {{ domain.operator.label }}
                              @if (isValidDate(domain.text)) {
                                {{ domain.text | date : "dd-MM-yyyy" }}
                              } @else {
                                {{ domain.text }}
                              }
                              <span translate>GLOBAL_MSG_AND</span>
                              @if (isValidDate(domain.text2)) {
                                {{ domain.text2 | date : "dd-MM-yyyy" }}
                              } @else {
                                {{ domain.text2 }}
                              }
                            </span>
                          }
                          @default {
                          }
                        }
                      </span>
                    </button>
                  }
                  @if (!isLast) {
                    <div class="dropdown-divider"></div>
                  }
                </div>
              }
            }
            @if (!!view.fields && view.fields.length > 0) {
              <!-- add a divider if there is element before -->
              @if ((view.searchView.builtInFilterGroups != null && view.searchView.builtInFilterGroups.length !== 0) ||
                hasReadOnlyFilters(view.searchView.propertyFilters) ||
                customFilters != null && customFilters.length !== 0) {
                <div class="dropdown-divider"></div>
              }
              <button ngbDropdownItem (click)="addCustomFilter()" translate>
                SEARCH_LBL_CUSTOM_CUSTOM_FILTER_ADD
              </button>
              @for (index of this.domains; track index) {
                <app-search-custom-filter
                  (removeFilter)="removeCustomFilter($event)"
                  [searchModuleIndex]="this.domains.indexOf(index)"
                  />
              }
              @if (this.domains.length > 0) {
                <div ngbDropdownItem>
                  <button
                    class="btn btn-sm btn-primary mr-2"
                    (click)="applyCustomFilter()"
                    translate
                    >
                    GLOBAL_BTN_APPLY
                  </button>
                  <button
                    class="btn btn-sm btn-outline-primary"
                    (click)="addCustomFilter()"
                    translate
                    >
                    SEARCH_LBL_CUSTOM_CONDITION_ADD
                  </button>
                </div>
              }
            }
          }
        </div>
      }
    </div>
    @if (showFavorite()) {
      <div ngbDropdown class="dropdown dropdown-filter d-inline">
        <button
          type="button"
          class="btn btn-sm btn-outline-light dropdown-toggle"
          id="dropdownBasic2"
          ngbDropdownToggle
          >
          <i class="mdi mdi-star"></i>
          <span class="btn-text" translate> SEARCH_LBL_CUSTOM_FAVORITE </span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownFavorites">
          <button ngbDropdownItem (click)="saveFavorite()" translate>
            SEARCH_LBL_CUSTOM_FAVORITE_ADD
          </button>
        </div>
      </div>
    }
  </div>
}
